import { render, staticRenderFns } from "./Weight.vue?vue&type=template&id=038c49b6&scoped=true&"
import script from "./Weight.vue?vue&type=script&lang=js&"
export * from "./Weight.vue?vue&type=script&lang=js&"
import style0 from "./Weight.vue?vue&type=style&index=0&id=038c49b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038c49b6",
  null
  
)

export default component.exports